module.exports = __webpack_public_path__ + "img/63.8f1bf909.jpg";